import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Observable, Subject, Subscription, map } from 'rxjs';
import { CompetencyDTO } from 'src/app/common/dtos/competency.dto';
import { v4 as uuidv4 } from 'uuid';
import { CompetenciesSelectService } from '../../services/competencies/competencies-select.service';

@Component({
  selector: 'app-competency-select',
  templateUrl: './competency-select.component.html',
  styleUrls: ['./competency-select.component.scss'],
})
export class CompetencySelectComponent implements OnInit {
  competencyList: Observable<CompetencyDTO[]>;

  competencyLibrary: CompetencyDTO[] = [];

  searchInput$ = new Subject<string>();

  searchSubscription: Subscription | null;

  searchLoading = false;

  labelId = uuidv4();

  internalSelectedCompetency: CompetencyDTO | null = null;

  internalSelectedCompetencyList: CompetencyDTO[] = [];

  @ViewChild('select') select: NgSelectComponent;

  @Input() clearAfterSelection = false;

  @Input() label = 'Search for and select a competency';

  @Input() placeholder = 'Search for a competency...';

  @Input() hideTags = false;

  @Input() isMulti = false;

  @Input() defaultCompetencies: number[] | CompetencyDTO[] | null;

  @Output() selectedCompetency: EventEmitter<CompetencyDTO | null> =
    new EventEmitter();

  @Output() selectedCompetencyList: EventEmitter<CompetencyDTO[]> =
    new EventEmitter();

  constructor(private competencySearch: CompetenciesSelectService) {}

  ngOnInit(): void {
    this.competencyList = this.competencySearch.items.pipe(
      map((competencies) => {
        this.competencyLibrary = [...this.competencyLibrary, ...competencies];
        this.searchLoading = false;
        return competencies;
      })
    );
    this.searchInput$.subscribe((term) => {
      this.searchLoading = true;
      return this.competencySearch.search(term);
    });

    if (this.defaultCompetencies) {
      const competencyIds =
        /* eslint-disable-next-line no-nested-ternary */
        typeof this.defaultCompetencies === 'number'
          ? [this.defaultCompetencies]
          : typeof this.defaultCompetencies[0] === 'number'
          ? this.defaultCompetencies
          : this.defaultCompetencies.map((c) => (c as CompetencyDTO).id);
      competencyIds.forEach((competencyId) => {
        this.competencySearch
          .getCompetency(competencyId as number)
          .subscribe((competency) => {
            if (competency) {
              if (this.isMulti) {
                this.internalSelectedCompetencyList.push(competency);
              } else {
                this.internalSelectedCompetency = competency;
              }
            }
          });
      });
    }
  }

  competencySelected(competency: CompetencyDTO) {
    if (this.isMulti && competency) {
      if (!this.internalSelectedCompetencyList.includes(competency)) {
        this.internalSelectedCompetencyList.push(competency);
      }
      this.select.handleClearClick();
    } else {
      this.internalSelectedCompetency = competency;
    }
    this.outputDistricts();
    if (this.clearAfterSelection) {
      // Without a timeout you get infinite recursion
      setTimeout(() => {
        this.select.unselect(this.select.selectedItems[0]);
      });
    }
  }

  outputDistricts() {
    if (this.isMulti) {
      this.selectedCompetencyList.emit(this.internalSelectedCompetencyList);
    } else {
      this.selectedCompetency.emit(this.internalSelectedCompetency);
    }
  }

  removeCompetencyFromList(competency: CompetencyDTO) {
    this.internalSelectedCompetencyList =
      this.internalSelectedCompetencyList.filter(
        (item) => item.id !== competency.id
      );
    this.outputDistricts();
  }

  reset() {
    if (this.isMulti) {
      this.internalSelectedCompetencyList = [];
    } else {
      this.internalSelectedCompetency = null;
    }
    this.select.selectedItems.forEach((item) => {
      this.select.unselect(item);
    });
  }
}
